// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.


export const domainCreditsPurchaseDto = {
    credits: 'credits',
    note: 'note',
} as const;

export type TDomainCreditsPurchaseDto = (typeof domainCreditsPurchaseDto)[keyof typeof domainCreditsPurchaseDto];

export interface IDomainCreditsPurchaseDto {
    [domainCreditsPurchaseDto.credits]: number | null;
    [domainCreditsPurchaseDto.note]: string | null;
}

export class DomainCreditsPurchaseDto
    implements IDomainCreditsPurchaseDto
{
    [domainCreditsPurchaseDto.credits]: number | null = null;
    [domainCreditsPurchaseDto.note]: string | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IDomainCreditsPurchaseData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[domainCreditsPurchaseDto.guid] = modelData[domaincreditspurchaseData.guid];
    }

    static create(modelData?: any | null): IDomainCreditsPurchaseDto | null {
        return modelData ? new DomainCreditsPurchaseDto(modelData) : null;
    }
}
